const getNotificationPromptValueInLocalStorage = () => {
	const {
		hasAccepted = false,
		lastTimeAsked = null,
		views = 0,
	} = JSON.parse(
		window.localStorage.getItem("airship-notification-prompt")
	) || {};

	return {
		hasAccepted,
		lastTimeAsked,
		views,
	};
};

export default getNotificationPromptValueInLocalStorage;
